import { render, staticRenderFns } from "./stockProductHome.vue?vue&type=template&id=e13c2e50&scoped=true&"
import script from "./stockProductHome.vue?vue&type=script&lang=js&"
export * from "./stockProductHome.vue?vue&type=script&lang=js&"
import style0 from "./stockProductHome.vue?vue&type=style&index=0&id=e13c2e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13c2e50",
  null
  
)

export default component.exports